import axios from "../utils/axios";

export const getUgcSection = async () => {
    const response = await axios.get('/settings/ugc-page');
    return response.data;
};

export const updateUgcSection = async (data) => {
    const response = await axios.put('/settings/ugc-page', data);
    return response.data;
};
